module.exports = __webpack_public_path__ + "img/calendar.e360d0eb.svg";